import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { inviteMapSharingFailure, inviteMapSharingSuccess } from "domains/createShareSettings/actions";
import type { MapInviteDefaultAction } from "domains/createShareSettings/actionTypes";
import type { TopicAccessEmailPost } from "domains/topicshare/topicshare.types";

export function* createInvitationSaga(action: MapInviteDefaultAction) {
  try {
    const topic_id = action.meta.mapId;
    const body: TopicAccessEmailPost = {
      invitations: { shared_users: action.meta.invitations.map(({ email, permission }) => ({ email, permission })) },
    };
    yield apiFetch(`topic/${topic_id}/access/email`, { body, method: "POST" });
    yield put(inviteMapSharingSuccess(action.meta.invitations, action.meta));
  } catch {
    yield put(inviteMapSharingFailure(action.meta));
  }
}
